export const getCanonicalSeoPath = (seoUrls = []) => {
    const valid = seoUrls.filter(s => s && !s.isDeleted && s.seoPathInfo);

    return (valid.find(s => s.isCanonical) || valid[0])?.seoPathInfo || '';
};

export const getProductUrl = (product, locale = document.documentElement.lang || 'nl') => {
    const path = product?.seoPathInfo
        ? product.seoPathInfo.split('/').map(encodeURIComponent).join('/')
        : product?.id;

    return `/${locale}/s/${path}`;
};
